import { z } from 'zod'

import { LEGAL_CONSTANTS } from '@flows/configs/legal/constants'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import * as validators from '@flows/configs/shared/validators'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { FAILURE_STEP_NAME } from '@flows/insurance/constants'
import { BaseSchema_LegalBasis3BasicRolandDe } from '@flows/insurance/schemas'

const claimsOptionsFromSchema = schemaUtils.getEnumValuesFromPipelineSchema(
  BaseSchema_LegalBasis3BasicRolandDe.shape.number_of_claims_in_last_5y.unwrap()
)

const legal_damages = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('number_of_claims_in_last_5y')]:
        validators.createPreprocessedEnumNumberSchema(z.enum([...claimsOptionsFromSchema, '4'])),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_legal:steps.legal_3.damages.title',
        },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('number_of_claims_in_last_5y'),
        options: LEGAL_CONSTANTS.claimsOptions,
      },
      {
        type: 'infoBox',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_legal:steps.damages.infoText',
        },
      },
    ],
    subFlow: params.subFlow,
    nextStepConfig: {
      valuePath: params.helperFunctions.getParamPath('number_of_claims_in_last_5y'),
      valueToStepName: {
        0: 'legal_insurance_cancelled_by',
        1: 'legal_insurance_cancelled_by',
        2: 'legal_insurance_cancelled_by',
        3: 'legal_insurance_cancelled_by',
        4: FAILURE_STEP_NAME,
      },
    },
  }) as const satisfies AnyStepConfiguration

export default legal_damages
